/**
 * NZSC-3998: 카카오 로그인 `state` 에 실어 보내는 영업 핸드오프 토큰 조립·분리(순수 함수).
 * 인앱 브라우저에서 시작한 로그인이 카카오 앱을 거쳐 다른 브라우저(사파리)로 돌아오면
 * 쿠키·localStorage 가 없으므로 state 만이 클릭을 잇는다.
 * 형식: `<base>|sa=<token>`. 기존 state 도 `|` 를 구분자로 쓰므로(`address_reinput|…`, `reels|kre|…`)
 * 우리가 붙인 마지막 `|sa=<token>` 만 떼고 나머지는 원문 그대로 둔다.
 */
export const SALES_HANDOFF_STATE_KEY = "sa";
const HANDOFF_STATE_SUFFIX = /^([\s\S]*?)\|sa=(\d{1,20}~\d{13}~[A-Za-z0-9_-]{32})$/;

export function joinSalesHandoffState(state, token) {
  const base = String(state ?? "");
  return token ? `${base}|${SALES_HANDOFF_STATE_KEY}=${token}` : base;
}

export function splitSalesHandoffState(rawState) {
  const raw = typeof rawState === "string" ? rawState : "";
  const match = HANDOFF_STATE_SUFFIX.exec(raw);
  return match
    ? { state: match[1], handoffToken: match[2] }
    : { state: raw, handoffToken: null };
}
